import React, { useEffect, useState } from 'react'

import "common/css/master.css";


function StaffDtlsTbl(props) {
    const { staffId, lstStaff, handleSelectStaff, editStaff, selectStaffClassSubject } = props;

    const [selStaffId, setSelStaffId] = useState(0);
    const [lstStaffTbl, setLstStaffTbl] = useState([]);

    useEffect(() => {
        // console.log("StaffDtlsTbl called, staffId", staffId);
        setSelStaffId(staffId);
    }, [staffId]);

    useEffect(() => {
        // console.log("StaffDtlsTbl called,lstStaff", lstStaff);
        setLstStaffTbl(lstStaff);
    }, [lstStaff]);


    const colgrp = <colgroup>
        <col width="80"></col>
        <col width="40"></col>
        <col width="50"></col>
        <col width="40"></col>
    </colgroup>

    return (
        <div >
            <div className="col-md-12 col-xs-12 col-centered padding-remove " >
                <table className="tableLayout1" >
                    {colgrp}
                    <thead>
                        <tr>
                            <th >
                                Name
                            </th>
                            <th >
                                Role
                            </th>
                            <th >
                                Class Teacher of
                            </th>
                            <th >
                                Action
                            </th>
                        </tr>
                    </thead>
                </table>
                <div className="tableDiv" style={{ height: "70vh" }}>
                    <table className="tableLayout">
                        {colgrp}
                        <tbody id="stffDtlsTbl" >
                            {lstStaffTbl &&
                                lstStaffTbl.map((staff, idx) => (
                                    <tr key={staff.staffId + "_" + staff.roleId + "_" + staff.sectionId}
                                        onClick={() => handleSelectStaff(staff)}
                                        className={staff.staffId === selStaffId ? "selected" : ''}>
                                        <td className="text-left">{staff.staff}</td>
                                        <td className="text-center">{staff.role}</td>
                                        <td className="text-center">{staff.clsSection}</td>
                                        <td className="text-center" >
                                            <span
                                                onClick={() => editStaff(staff)}
                                                title="Edit Staff Details"
                                                style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "5px" }}
                                            >
                                                Edit
                                            </span>
                                            <span
                                                onClick={() => selectStaffClassSubject(staff)}
                                                title="Select Class Subjects"
                                                style={{ textDecoration: "underline", cursor: "pointer", color: "blue", margin: "5px" }}
                                            >
                                                Class-Subject
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default StaffDtlsTbl;